export const querySizeMappings = {
	sm: 640,
	md: 768,
	lg: 1324,
	xl: 1759,
	"2xl": 1780,
} satisfies Record<string, number>;
